import { configOption, configSubObject } from "../lib/annotations";
import { EmailOptions } from "./emailOptions";
import { WhatsappOptions } from "./whatsappOptions";
import { SmsOptions } from "./smsOptions";
import { SubscriptionOptions } from "./subscriptionOptions";

export class WebhookOptions {
  @configOption({})
  "url": string;

  @configOption({})
  "secret"?: string;

  @configOption({})
  "enabled"?: boolean;
}
export class BackofficeConfig {
  @configSubObject({
    displayName: "Webhook Configuration",
  })
  webhook?: WebhookOptions;
  @configSubObject({
    displayName: "Email Configuration",
    description: "currently we only support email.js as email provider",
  })
  email?: EmailOptions;
  @configSubObject({
    displayName: "Whatsapp Configuration",
    description: "authentication, keys, message templates, and touch-points",
  })
  whatsapp?: WhatsappOptions;

  @configSubObject({
    displayName: "SMS Configuration",
    description: "from number, message templates, and touch-points",
  })
  sms?: SmsOptions;

  @configSubObject({
    displayName: "Subscription Options",
    description:
      "official organization name, point of contact and plan and billing information",
  })
  subscriptionOptions?: SubscriptionOptions;
}
